import React from "react";
import {connect} from "react-redux";
import {Dimensions, FlatList, KeyboardAvoidingView, StyleSheet, Text, View} from "react-native";
import TendancetListItem from "../Tendance/TendancetListItem";
import LexicalSectionList from "../LexicalSectionList/LexicalSectionList";
import BarreRecherche from "../Header/BarreRecherche";
import PostList from "../Feed/PostFeed/PostList";

import { debounce } from "../../utils/func";

class ExplorerContactList extends React.Component{
    constructor(props) {
        super(props);

        this.setSearch = debounce(this.setSearch.bind(this), 200);
    }
    setSearch(text) {
      this.props.setSearch(text);
    }

    render(){
        // avoid at render...
        const { width, height } = Dimensions.get('window');
        return (
            <View style={{width:width,marginBottom:0,flex:1}}>
                <View style={{width:width,alignItems:"center"}}>
                    <View style={{width:"90%",height:60,marginHorizontal:10}}>
                        <BarreRecherche search={this.setSearch} text={this.props.search} fullScreen={true} active={this.props.online} />
                    </View>
                </View>
                <PostList bookmark={this.props.bookmark} isExplorer={true} loadMore={this.props.loadMore}
                          refNavigation={this.props.refNavigation} isRefresh={false} refresh={()=>{}} data={this.props.data} />
            </View>
        );
    }
}

const mapStateToProps = (state) => {
    return {
      isDark: state.changeTheme.isDark, theme: state.changeTheme.theme, auth: state.AuthReducer,
      online: state.sw_reducer.online
    };
}

export default connect(mapStateToProps)(ExplorerContactList);
